module.exports = __webpack_public_path__ + "img/1.56bb8179.jpg";